import { AdverseActionLetterType } from "api/landlord/templates/types";
import { FlowConfig } from "./types";
import { Views } from "./types";

const genericApplicationConditions = [
  {
    id: "inadequate_income",
    text: "Inadequate income assets"
  },
  {
    id: "unverified_income",
    text: "Unverified income assets"
  },
  {
    id: "income_documents_fraud_risk_detected",
    text: "Income documents fraud risk detected"
  },
  {
    id: "smoking_habits",
    text: "Smoking habits"
  },
  {
    id: "criminal_record_history",
    text: "Criminal record history"
  },
  {
    id: "registered_sex_offender_record",
    text: "Registered sex offender record"
  },
  {
    id: "non_permitted_pets",
    text: "Non-permitted pets"
  },
  {
    id: "rental_history",
    text: "Rental history is lacking"
  },
  {
    id: "history_of_non_payment_or_tardiness",
    text: "History of non-payment or tardiness"
  },
  {
    id: "history_of_rental_property_damage",
    text: "History of rental property damage"
  },
  {
    id: "application_info_misrepresented",
    text: "Application info misrepresented"
  },
  {
    id: "incomplete_application",
    text: "Incomplete application"
  },
  {
    id: "credit_background_check_not_authorized",
    text: "Credit/background check not authorized"
  },
  {
    id: "credit_score_doesnt_meet_renting_criteria",
    text: "Credit score(s) of application group doesn’t meet renting criteria"
  },
  {
    id: "past_due_accounts",
    text: "Past due accounts"
  },

  {
    id: "accounts_in_collections",
    text: "Accounts in collections"
  },
  {
    id: "history_of_bankruptcy",
    text: "History of bankruptcy"
  },

  {
    id: "history_of_eviction",
    text: "History of housing court proceedings"
  },
  {
    id: "negative_employer_reference",
    text: "Negative employer reference"
  },

  {
    id: "disagreement_on_terms_of_rental_agreement",
    text: "Disagreement on terms of rental agreement"
  }
];

const waApplicationConditions = [
  {
    id: "information_contained_in_a_consumer_report",
    text: "Information contained in a consumer report"
  },
  {
    id: "the_consumer_credit_report_did_not_contain_sufficient_information",
    text: "The consumer credit report did not contain sufficient information"
  },
  {
    id: "information_received_from_previous_rental_history_or_reference",
    text: "Information received from previous rental history or reference"
  },
  {
    id: "information_received_in_a_criminal_record",
    text: "Information received in a criminal record"
  },
  {
    id: "information_received_in_a_civil_record",
    text: "Information received in a civil record"
  },
  {
    id: "information_received_from_an_employment_verification",
    text: "Information received from an employment verification"
  }
];

export const conditionsByAdverseActionLetterType = {
  [AdverseActionLetterType.Generic]: genericApplicationConditions,
  [AdverseActionLetterType.Washington]: waApplicationConditions
};

export const residencyConditions = [
  {
    id: "increased_deposit",
    text: "Increased deposit"
  },
  {
    id: "qualified_guarantors",
    text: "Qualified guarantors"
  },
  {
    id: "last_months_rent",
    text: "Last month’s rest"
  },
  {
    id: "increased_monthly_rent",
    text: "Increased monthly rent"
  }
];

export const conditionsMap = {
  bankruptcy_records: "History of bankruptcy",
  credit_score: "Credit score did not meet rental criteria",
  gross_income: "Inadequate income assets",
  gross_income_to_rent_ratio: "Inadequate income assets",
  housing_court_records: "History of housing court proceedings",
  net_income: "Inadequate income assets",
  past_due_account: "Past due accounts",
  sex_offender_check: "Registered sex offense record",
  unpaid_collections_balance: "Past due accounts",
  collections_balance: "Accounts in collections",
  debt_to_net_income: "Inadequate income assets",
  felony_records: "Criminal record history",
  misdemeanor_records: "Criminal record history",
  ofac_records: "Criminal record history",
  other_criminal_records: "Criminal record history",
  income_document_fraud_check: "Income documents fraud risk detected"
};

export const operatorMessages = {
  ">": "greater than",
  ">=": "greater than or equal to",
  "<": "less than",
  "<=": "less than or equal to",
  "==": "equal to",
  "!=": "not equal to"
};

export const fieldTypeMessages = {
  any: "at least one applicant had",
  all: "all applicants had",
  sum: "the total number of",
  numeric: "a numeric value of",
  percentage: "a percentage of",
  average: "the group average of",
  min: "the minimum value of",
  max: "the maximum value of",
  all_time: "all",
  within_1_year: "within 1 year",
  within_2_years: "within 2 years",
  within_3_years: "within 3 years",
  within_4_years: "within 4 years",
  within_5_years: "within 5 years",
  within_6_years: "within 6 years",
  within_7_years: "within 7 years",
  within_8_years: "within 8 years",
  within_9_years: "within 9 years",
  within_10_years: "within 10 years"
};

export const conditionKeysMap = {
  bankruptcy_records: "history_of_bankruptcy",
  credit_score: "credit_score_doesnt_meet_renting_criteria",
  gross_income: "inadequate_income",
  gross_income_to_rent_ratio: "inadequate_income",
  housing_court_records: "history_of_eviction",
  net_income: "inadequate_income",
  past_due_account: "past_due_accounts",
  sex_offender_check: "registered_sex_offender_record",
  unpaid_collections_balance: "past_due_accounts",
  collections_balance: "accounts_in_collections",
  debt_to_net_income: "inadequate_income",
  felony_records: "criminal_record_history",
  misdemeanor_records: "criminal_record_history",
  ofac_records: "criminal_record_history",
  other_criminal_records: "criminal_record_history",
  income_document_fraud_check: "income_documents_fraud_risk_detected"
};

export const flows: FlowConfig = {
  decline: [
    Views.MakeDecision,
    Views.Conditions,
    Views.DecisionSettings,
    Views.Email,
    Views.Success
  ],
  conditional_approve: [
    Views.MakeDecision,
    Views.Conditions,
    Views.ResidencyConditions,
    Views.DecisionSettings,
    Views.Email,
    Views.Success
  ],
  approve: [
    Views.MakeDecision,
    Views.DecisionSettings,
    Views.Email,
    Views.Success
  ]
};
